import {AUTH_LOGOUT} from "@/store/mutation-types"
export default {
	computed: {
		$_loggedUser_userId() {
			return this.$store.getters.getLoggedUserId
		},
		$_loggedUser_selectedOperatorId(){
			if (this.$_loggedUser_canChangeOperator){
				return this.$store.getters.getSelectedOperatorId;
			}else{
				return this.$store.getters.operatorId;
			}
		},
		$_loggedUser_isChangedOperator(){
			if(!this.$_loggedUser_canChangeOperator){
				return false;
			}else{
				return this.$store.getters.getSelectedOperatorId != this.$store.getters.operatorId;
			}
		},
		$_loggedUser_canChangeOperator(){
			let userRoleList = this.$store.getters.getUserRoleList;
			this.checkUserRoleList(userRoleList);
			if (userRoleList.hasOwnProperty('changeOperator')
				&& userRoleList['changeOperator'].hasOwnProperty('update')
			) {
				return userRoleList['changeOperator']['update'] !== 'NONE';
			}else{
				return false
			}
		},
		$_loggedUser_operatorId() {
			return this.$store.getters.operatorId
		},
		$_loggedUser_getOperator() {
			return this.$store.getters.getLoggedOperator
		},
		$_loggedUser_canCreateChannelPackage() {
			return !this.$_loggedUser_getOperator
				|| (this.$_loggedUser_getOperator.hasOwnProperty('can_create_channel_package')
					&& this.$_loggedUser_getOperator['can_create_channel_package'] !== false);
		},
		$_loggedUser_canModifyOwnChannelPackages() {
			return !this.$_loggedUser_getOperator
					|| (this.$_loggedUser_getOperator.hasOwnProperty('can_add_channels_to_own_channel_package')
						&& this.$_loggedUser_getOperator['can_add_channels_to_own_channel_package'] !== false);
		},
		$_loggedUser_canAddChannelsToService() {
			return !this.$_loggedUser_getOperator
				 || (this.$_loggedUser_getOperator.hasOwnProperty('can_add_channels_to_service')
				&& this.$_loggedUser_getOperator['can_add_channels_to_service'] !== false);
		},
		$_createActionAllowed(){
			return this.$_loggedUser_action_allowed(this.$route.meta.sectionName, 'create');
		},
		$_createActionAllowedAll(){
			return this.$_loggedUser_action_allowed(this.$route.meta.sectionName, 'create', 'ALL');
		},
		$_createActionAllowedAllOrOwnAndGlobal(){
			return this.$_loggedUser_action_allowed(this.$route.meta.sectionName, 'create', ['ALL', 'OWN_AND_GLOBAL']);
		},
		$_readActionAllowed(){
			return this.$_loggedUser_action_allowed(this.$route.meta.sectionName, 'read');
		},
		$_readActionAllowedAll(){
			return this.$_loggedUser_action_allowed(this.$route.meta.sectionName, 'read', 'ALL');
		},
		$_readActionAllowedAllOrOwnAndGlobal(){
			return this.$_loggedUser_action_allowed(this.$route.meta.sectionName, 'read', ['ALL', 'OWN_AND_GLOBAL']);
		},
		$_updateActionAllowed(){
			return this.$_loggedUser_action_allowed(this.$route.meta.sectionName, 'update');
		},
		$_updateActionAllowedAll(){
			return this.$_loggedUser_action_allowed(this.$route.meta.sectionName, 'update', 'ALL');
		},
		$_updateActionAllowedAllOrOwnAndGlobal(){
			return this.$_loggedUser_action_allowed(this.$route.meta.sectionName, 'update', ['ALL', 'OWN_AND_GLOBAL']);
		},
		$_deleteActionAllowed(){
			return this.$_loggedUser_action_allowed(this.$route.meta.sectionName, 'delete');
		},
		$_deleteActionAllowedAll(){
			return this.$_loggedUser_action_allowed(this.$route.meta.sectionName, 'delete', 'ALL');
		},
		$_deleteActionAllowedAllOrOwnAndGlobal(){
			return this.$_loggedUser_action_allowed(this.$route.meta.sectionName, 'delete', ['ALL', 'OWN_AND_GLOBAL']);
		},
	},
	methods: {
		$_loggedUser_route_allowed(route) {
			const always_allowed_route_names = ['myOperatorDetail', 'landingPage'];
			const sectionName = route.meta.sectionName;
			const action = route.meta.action ? route.meta.action : 'read';

			return this.$_loggedUser_action_allowed(sectionName, action)
				|| !route.meta.hasOwnProperty('requiresAuth')
				|| !route.meta.requiresAuth
				|| always_allowed_route_names.includes(route)
		},
		$_loggedUser_action_allowed(sectionName, action = 'read', accessLevel = null){
			if(typeof accessLevel === 'string'){
				accessLevel = [accessLevel];
			}
			let userRoleList = {};
			let selectedOperatorId = !this.$_loggedUser_canChangeOperator ? this.$_loggedUser_operatorId : this.$store.getters.getSelectedOperatorId;
			if(selectedOperatorId){
				userRoleList = this.$store.getters.getOperatorRoleList;
			}else {
				userRoleList = this.$store.getters.getUserRoleList;
			}
			this.checkUserRoleList(userRoleList);
			if (sectionName
				&& userRoleList.hasOwnProperty(sectionName)
				&& userRoleList[sectionName].hasOwnProperty(action)
			) {
				if(!accessLevel){
					let role = userRoleList[sectionName][action];
					switch(role){
						case 'ALL':
						case 'OWN_AND_GLOBAL':
							return true;
						case 'GLOBAL':
							return selectedOperatorId == null;
						case 'OWN':
							return this.$_loggedUser_operatorId == null || selectedOperatorId == this.$_loggedUser_operatorId;
						default:
							return false;
					}
				}else{
					return accessLevel.includes(userRoleList[sectionName][action]);
				}
			}
			return false;
		},
		$_loggedUser_getRoleForSection(sectionName, action){
			const userRoleList = this.$store.getters.getUserRoleList;
			this.checkUserRoleList(userRoleList);
			return userRoleList[sectionName][action];
		},
		$_loggedUser_operator_item_delete_action_allowed(itemOperatorId, sectionName = null) {
			return this.$_loggedUser_operator_item_action_allowed(itemOperatorId, 'delete', sectionName)
		},
		$_loggedUser_operator_item_update_action_allowed(itemOperatorId, sectionName = null) {
			return this.$_loggedUser_operator_item_action_allowed(itemOperatorId, 'update', sectionName)
		},
		$_loggedUser_operator_item_action_allowed(itemOperatorId, action, sectionName){
			if(itemOperatorId == 0){
				itemOperatorId = null;
			}
			if(!sectionName){
				sectionName = this.$route.meta.sectionName;
			}
			let selectedOperatorId = this.$store.getters.getSelectedOperatorId ? this.$store.getters.getSelectedOperatorId : this.$_loggedUser_operatorId;
			let userRoleList = {};
			if(selectedOperatorId){
				userRoleList = this.$store.getters.getOperatorRoleList;
			}else {
				userRoleList = this.$store.getters.getUserRoleList;
			}
			this.checkUserRoleList(userRoleList);

			if (sectionName
				&& userRoleList.hasOwnProperty(sectionName)
				&& userRoleList[sectionName].hasOwnProperty(action)
			) {
				switch (userRoleList[sectionName][action]) {
					case 'OWN':
						return itemOperatorId == selectedOperatorId;
					case 'GLOBAL':
						return itemOperatorId == null;
					case 'OWN_AND_GLOBAL':
						return itemOperatorId == null || itemOperatorId == selectedOperatorId;
					case 'ALL':
						return true;
					default:
						return false;
				}
			}
			return false;
		},
		$_get_section_type(sectionName){
			let userRoleList = this.$store.getters.getUserRoleList;
			this.checkUserRoleList(userRoleList);
			if(userRoleList.hasOwnProperty(sectionName)
			&& userRoleList[sectionName].hasOwnProperty('type')){
				return userRoleList[sectionName]['type'];
			}else{
				return null;
			}
		},
		checkUserRoleList(userRoleList){
			if(!Object.keys(userRoleList).length && this.$store.getters.getLoggedUserId){
				this.$store.dispatch(AUTH_LOGOUT)
					.then(() => {
						this.$router.push({name: 'login'})
					})
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/global/logged-user.js